var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasNavigationBar
    ? _c(
        "div",
        { staticClass: "pl-[248px] w-full" },
        [
          _c("jade-navigation-bar", {
            staticClass: "h-16",
            attrs: {
              label: _vm.$t(_vm.label),
              navigateType: _vm.navigateType,
              hideNavigation: _vm.hideNavigation,
              background: "body",
            },
            on: { onNavigate: _vm.onNavigate },
            scopedSlots: _vm._u(
              [
                _vm.navigationAction
                  ? {
                      key: "trailingItem",
                      fn: function () {
                        return [
                          _vm.navigationAction?.click
                            ? _c(
                                "jade-button",
                                {
                                  attrs: {
                                    size: "medium",
                                    variant: "primary-solid",
                                  },
                                  on: { click: _vm.navigationAction.click },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(_vm.navigationAction.label)
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm.navigationAction?.component
                            ? _c(_vm.navigationAction.component, {
                                tag: "component",
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }